"use client";
import TextDecreaseIcon from "@mui/icons-material/TextDecrease";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { AnalyticsEvents, trackEvent } from "~/connectors/analytics.connector";
import { CSS_VARIABLE_FONT_SIZE, LOCAL_STORAGE_KEY_FONT_SIZE, MAX_FONT_SIZE, MIN_FONT_SIZE } from "./versuriFontSizeConstants";

export default function VersuriFontSizeControls() {
  const updateFontSize = (deltaSize: number) => {
    const crtSize = getComputedStyle(document.documentElement).getPropertyValue(CSS_VARIABLE_FONT_SIZE).trim();
    const crtSizeNum = parseInt(crtSize.replace("px", ""), 10);
    let newSize = crtSizeNum + deltaSize;
    // apply max min
    newSize = Math.max(MIN_FONT_SIZE, Math.min(MAX_FONT_SIZE, newSize));

    if (newSize >= MIN_FONT_SIZE && newSize <= MAX_FONT_SIZE) {
      localStorage.setItem(LOCAL_STORAGE_KEY_FONT_SIZE, newSize.toString());
      document.documentElement.style.setProperty(CSS_VARIABLE_FONT_SIZE, newSize + 'px');

      // Manually trigger the 'storage' event so this window
      // updates immediately (storage event normally only fires in other tabs)
      window.dispatchEvent(new Event("storage"));
    }
  };

  const increaseFontSize = () => {
    updateFontSize(2);
    trackEvent(AnalyticsEvents.VERSURI_FONT_SIZE_INCREASE);
  };

  const decreaseFontSize = () => {
    updateFontSize(-2);
    trackEvent(AnalyticsEvents.VERSURI_FONT_SIZE_DECREASE);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0,
        alignSelf: { xs: "flex-end", md: "auto" },
      }}
    >
      <Button
        variant="text"
        size="small"
        color="inherit"
        onClick={decreaseFontSize}
        sx={{
          minWidth: 40,
          height: 40,
          borderRadius: "50%",
          p: 0,
        }}
      >
        <TextDecreaseIcon fontSize="small" />
      </Button>
      <Button
        variant="text"
        size="small"
        color="inherit"
        onClick={increaseFontSize}
        sx={{
          minWidth: 40,
          height: 40,
          borderRadius: "50%",
          p: 0,
        }}
      >
        <TextIncreaseIcon fontSize="small" />
      </Button>
    </Box>
  );
}
